import React, { useState } from 'react';
import { Avatar, Dropdown, Menu, Flex, Row, Col } from 'antd';
import styles from "./profilePopover.module.scss"
import CustomTypography from '../common/CustomTypography';
import LogoutIcon from '../../assets/icons/LogoutIcon';

const ProfileMenu = ({ onLogout, username = "Username", role = "Role" }) => {
  return (
    <Menu style={{ width: 230}} mode='vertical'>
      <Menu.Item key="username">
        <Flex>
            <Col>
            <Row>
                <CustomTypography
                    style={{
                        fontSize: "18px",
                        fontWeight: 500,
                        lineHeight: "22px",
                        fontFamily: "Satoshi"
                    }}
                >
                    {username}
                </CustomTypography>

            </Row>
            <Row>
                <CustomTypography
                    style={{
                        fontSize: "16px",
                        fontFamily: "Satoshi",
                        color: "#00000073",
                    }}
                >
                    {role}
                </CustomTypography>

            </Row>
            </Col>
        </Flex>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" onClick={onLogout}>
        <LogoutIcon />                
        <CustomTypography
            style={{
                fontFamily: "Satoshi",
                fontSize: '18px',
                marginLeft: '9px'
            }}
        >
            Log out
        </CustomTypography>
      </Menu.Item>
    </Menu>
  );
};

const ProfilePicture = ({ imageUrl, username, role, onLogout }) => {
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  return (
    <Dropdown
      overlay={<ProfileMenu username={username} role={role} onLogout={onLogout} />}
      trigger={['click']}
      onVisibleChange={handleVisibleChange}
      visible={visible}
    >
      <Avatar
        size="large"
        src={imageUrl}
        style={{
          cursor: 'pointer',
          borderRadius: '50%',
          backgroundColor: '#f0f0f0',
          marginLeft: '16px'
        }}

        className={styles.profileavatar}
      />
    </Dropdown>
  );
};

export default ProfilePicture
